import universal from 'react-universal-component';

export default universal(() => import('./News'));



// WEBPACK FOOTER //
// ./src/app/views/News/index.js